var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescuento20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171.2 134.8",
    style: {
      enableBackground: "new 0 0 171.2 134.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000005256683753818879730000017952848545798114956_);}\n\t.st2{fill:url(#SVGID_00000072995431174829589740000015501554336484064670_);}\n\t.st3{fill:url(#SVGID_00000096779961140077615490000013184844178163264183_);}\n\t.st4{fill:url(#SVGID_00000094581069072916855340000016567212702066544547_);}\n\t.st5{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.087,
    y1: 10.2256,
    x2: 18.1388,
    y2: 10.2256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E97722"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A25820"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,20.4H6.1c0,0,2.2-18.3,7.4-20.4C13.4,0,18.2,4.3,18.1,20.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176734249226742675800000001865149525440449467_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.1379,
    y1: 10.2256,
    x2: 166.1897,
    y2: 10.2256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A25820"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5703,
    style: {
      stopColor: "#E97722"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176734249226742675800000001865149525440449467_)"
    },
    d: "M154.1,20.4h12.1c0,0-2.2-18.3-7.4-20.4 C158.8,0,154.1,4.3,154.1,20.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035532882295727409000000008672835091346461627_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.6144,
    y1: 12.6765,
    x2: 85.6144,
    y2: 21.6583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666666"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    y: 8.5,
    style: {
      fill: "url(#SVGID_00000035532882295727409000000008672835091346461627_)"
    },
    width: 171.2,
    height: 11.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003094461202533755840000001869076550670104705_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.1552,
    y1: 5.49,
    x2: 90.1552,
    y2: 88.7265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02165772,
    style: {
      stopColor: "#E98922"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#898989"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003094461202533755840000001869076550670104705_)"
    },
    d: "M16.8,4.5c0,0,13.1,39,9.7,118 c-0.4,8.4,7.6,14.2,14.6,10.7l48.4-24.1l50.6,24.7c6.9,3.4,14.6-2.1,14.5-10.3c-0.4-37.1-0.2-120.1,8.9-119H16.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161593607784556410310000011514708017020475046_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.8042,
    y1: 1.0068,
    x2: 86.8042,
    y2: 84.2433
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02165772,
    style: {
      stopColor: "#E98922"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FC5804"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161593607784556410310000011514708017020475046_)"
    },
    d: "M13.4,0c0,0,13.1,39,9.7,118 c-0.4,8.4,7.6,14.2,14.6,10.7l48.4-24.1l50.6,24.7c6.9,3.4,14.6-2.1,14.5-10.3c-0.4-37.1-0.2-120.1,8.9-119H13.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.3,61.3H40.3v-4.7h11.9V61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.6,71.9H57.8v-4L67,57.3c1.4-1.7,2.3-3.1,2.9-4.2c0.6-1.1,0.9-2.2,0.9-3.2c0-1.3-0.3-2.3-0.9-3 c-0.6-0.8-1.5-1.1-2.7-1.1c-1.3,0-2.3,0.5-3,1.4c-0.7,1-1.1,2.2-1.1,3.6h-5.8l0-0.1c-0.1-2.7,0.8-5,2.6-6.9 c1.8-1.9,4.2-2.8,7.2-2.8s5.4,0.8,7.1,2.4s2.5,3.7,2.5,6.4c0,1.8-0.5,3.5-1.4,5c-0.9,1.5-2.6,3.6-4.9,6.2l-4.9,6l0,0.1h12.1V71.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.1,60.9c0,3.6-0.9,6.4-2.7,8.4c-1.8,2-4.2,3-7.2,3c-3,0-5.5-1-7.3-3c-1.8-2-2.7-4.8-2.7-8.4v-8.4 c0-3.5,0.9-6.3,2.7-8.4c1.8-2,4.2-3.1,7.2-3.1c3,0,5.4,1,7.2,3.1c1.8,2,2.7,4.8,2.7,8.4V60.9z M95.2,51.9c0-1.9-0.4-3.5-1.1-4.5 c-0.7-1.1-1.7-1.6-3-1.6c-1.3,0-2.3,0.5-3,1.6c-0.7,1.1-1.1,2.6-1.1,4.5v9.6c0,2,0.4,3.5,1.1,4.6c0.7,1.1,1.7,1.6,3,1.6 c1.3,0,2.3-0.5,3-1.6c0.7-1.1,1.1-2.6,1.1-4.6V51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105,47.4c0-1.8,0.6-3.3,1.7-4.5c1.1-1.2,2.7-1.8,4.7-1.8c2,0,3.6,0.6,4.7,1.8c1.1,1.2,1.7,2.7,1.7,4.5V49 c0,1.8-0.6,3.3-1.7,4.5c-1.1,1.2-2.7,1.8-4.7,1.8c-2,0-3.6-0.6-4.7-1.8c-1.1-1.2-1.7-2.7-1.7-4.5V47.4z M108.9,49 c0,0.8,0.2,1.5,0.6,2c0.4,0.5,1.1,0.8,1.9,0.8c0.8,0,1.4-0.3,1.8-0.8c0.4-0.5,0.6-1.2,0.6-2v-1.6c0-0.8-0.2-1.5-0.6-2.1 c-0.4-0.6-1-0.8-1.8-0.8s-1.4,0.3-1.8,0.8c-0.4,0.6-0.6,1.2-0.6,2.1V49z M112.4,69.6l-2.9-1.6l14.4-23.7l2.9,1.6L112.4,69.6z  M119.1,64.5c0-1.8,0.6-3.3,1.7-4.5s2.7-1.8,4.7-1.8c2,0,3.6,0.6,4.7,1.8s1.7,2.7,1.7,4.5v1.6c0,1.8-0.6,3.3-1.7,4.5 c-1.1,1.2-2.7,1.8-4.7,1.8c-2,0-3.6-0.6-4.8-1.8c-1.1-1.2-1.7-2.7-1.7-4.5V64.5z M123,66.1c0,0.8,0.2,1.5,0.7,2 c0.5,0.6,1.1,0.8,1.8,0.8c0.9,0,1.5-0.3,1.9-0.8c0.4-0.5,0.6-1.2,0.6-2.1v-1.6c0-0.8-0.2-1.5-0.6-2c-0.4-0.6-1-0.8-1.8-0.8 c-0.8,0-1.4,0.3-1.9,0.8c-0.4,0.6-0.6,1.2-0.6,2V66.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescuento20);
export default __webpack_public_path__ + "static/media/Descuento20.756b48a1f12ecbe8ec1956479ae8c027.svg";
export { ForwardRef as ReactComponent };